import * as validations from "./validation";

import RootService from "@services";

export default new RootService({ validations });
